import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

export const EconomicActivityForm = ({ dto, errorInputs, handleInputChange, t }) => {

    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12 }}>
                <Typography variant="h6">{t("suppliers.economicActivityTitle")}</Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    label={t('commonFields.name')}
                    name='type_ciiu'
                    value={dto.type_ciiu}
                    onChange={handleInputChange}
                    error={!!errorInputs.type_ciiu?.isError}
                    helperText={errorInputs.type_ciiu?.messageError}
                    required
                />
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    label={t('suppliers.economicActivity.code')}
                    name='code_ciiu'
                    value={dto.code_ciiu || ''}
                    onChange={handleInputChange}
                    error={!!errorInputs.code_ciiu?.isError}
                    helperText={errorInputs.code_ciiu?.messageError}
                    required
                />
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    name='description_ciiu'
                    label={t('suppliers.economicActivity.description')}
                    value={dto.description_ciiu}
                    onChange={handleInputChange}
                    error={!!errorInputs.description_ciiu?.isError}
                    helperText={errorInputs.description_ciiu?.messageError}
                    required
                />
            </Grid>
        </Grid>
    );
};
